import script from "./Step1Place.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1Place.vue?vue&type=script&setup=true&lang=js"

import "./Step1Place.vue?vue&type=style&index=0&id=26510d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26510d08"]])

export default __exports__